import { DocumentReportIcon } from '@heroicons/react/outline';

export function SpreadsheetFileIcon() {
  return <DocumentReportIcon className="h-full text-file-spreadsheet-enabled" />;
}
